export function AccessibilitySV() {
  return (
    <article>
      <h1>Tillgänglighet</h1>

      <h2>Vårt mål för universell design</h2>
      <p>
        Vi vill att vår molnlagringstjänst med webbplats, webbklient, mobil- och
        stationära appar ska vara tillgänglig och enkel att använda för alla.
      </p>
      <ul>
        <li>
          Minsta WCAG 2.1 nivå AA för alla nya leveranser; vi arbetar
          långsiktigt mot nivå AAA där det är praktiskt möjligt.
        </li>
        <li>
          Löpande uppföljning av WCAG-krav genom hela design-, utvecklings- och
          testprocessen.
        </li>
        <li>
          Tredjepartslösningar (t.ex. Microsoft Office Online-redigering)
          kontrolleras för att säkerställa att de uppfyller norska krav för
          universell design.
        </li>
      </ul>

      <h2>Hur tillgängliga är våra tjänster?</h2>
      <p>
        Vi har fortfarande delar av lösningen som inte är helt kompatibel med
        WCAG 2.1, men vi arbetar aktivt för att minska klyftan.
      </p>
      <ul>
        <li>
          2023 – 2024: Vi byggde ett nytt designsystem; alla nya
          gränssnittskomponenter är utvecklade med WCAG 2.1 nivå AA som ett
          minimikrav.
        </li>
        <li>
          2025 – 2026: Steg-för-steg-utrullning av designsystemet i webbklienten
          samt mobil- och stationära appar. Varje tjänst som lanseras i en "ny
          skepnad" kvalitetssäkras mot WCAG 2.1 före publicering.
        </li>
      </ul>

      <h2>Kända tillgänglighetsavvikelser och planerade lösningar</h2>

      <ul>
        <li>
          Allt icke-textinnehåll bör ha maskinläsbara textalternativ (A) -
          Rensat i samband med omdesign Q4 2025
        </li>
        <li>
          Vissa undersidor i administratörsgränssnittet saknar beskrivande
          titlar (A) - Implementerad tillsammans med ny header-komponent Q1 2026
        </li>
        <li>
          All funktionalitet måste vara tillgänglig via tangentbordet (saknas i
          skrivbordsapparna) (A) - Tangentbordsåtgärder läggs till kontinuerligt
          - starta Q3 2025
        </li>
        <li>
          Sekventiell fokusordning saknas i vissa skrivbordsdialoger (A)
          Implementerad av Q1 2026
        </li>
        <li>
          «Hoppa till huvudinnehåll» saknas i mobil webb (A) - Implementerad Q3
          2025
        </li>
        <li>
          Stöd för skärmläsare (JAWS, NVDA, VoiceOver) saknas från
          skrivbordsappen (A) - Ska implementeras före Q2 2026
        </li>
        <li>
          Inkonsekvent användning av UI-komponenter över sidor (AA) – Undersökt
          av fjärde kvartalet 2025
        </li>
        <li>
          Alla dra och släpp-operationer har inte fullt tangentbordsalternativ
          (AA) - Undersökt av Q4 2025
        </li>
        <li>
          Felmeddelanden ger inte alltid adekvat vägledning (AA) - Ska
          förbättras i slutet av fjärde kvartalet 2025
        </li>
        <li>
          400 % zoom vid 1280 px bredd kan ge horisontell rullning i vissa
          filgallerier på webben (AA) - Ska optimeras Q4 2025
        </li>
        <li>
          Text i äldre skrivbordsdialoger skalas inte alltid korrekt till 200 %
          (AA) - Ny skrivbordsversion före Q1 2026
        </li>
        <li>
          Alla UI-komponenter ska visa synligt fokus när de tar emot
          tangentbordsfokus (AAA) (saknar i skrivbordsapparna - Planeras att
          undersökas av fjärde kvartalet 2025
        </li>
        <li>
          Tillhandahålla mekanismer för att identifiera uttal av ord (AAA) –
          Planeras att utredas före Q2 2026
        </li>
        <li>
          Fyll i tidigare information automatiskt eller gör den tillgänglig för
          urval (AAA) - Planerad undersökt av Q4 2025
        </li>
      </ul>

      <h2>Hur arbetar vi med universell design?</h2>
      <ul>
        <li>
          Kontinuerlig förbättring av rutiner för att säkerställa att nya
          produkter och tjänster är universellt utformade
        </li>
        <li>
          Alla nya komponenter testas mot WCAG 2.1 nivå AA innan de blir en del
          av designsystemet.
        </li>
        <li>Tydlig och tydlig språkanvändning i alla tjänster vi erbjuder</li>
        <li>Regelbunden översyn av befintliga lösningar</li>
        <li>
          Kontinuerlig förbättring av rutiner för att säkerställa att nya
          produkter och tjänster är universellt utformade
        </li>
        <li>
          När vi upptäcker problem (via interna tester, support eller partners)
          loggas de in i vårt system och ingår i framtida utveckling
        </li>
      </ul>

      <h2>Hjälp oss att bli bättre</h2>

      <p>
        Upplever du hinder, eller tycker du att språket är svårt? Vänligen
        meddela oss. All feedback hjälper oss att bli mer tillgängliga!
      </p>

      <ul>
        <li>E-post: support@jottacloud.com</li>
        <li>
          Kontakta vårt kundcenter på (+ 47) 21 04 29 00 eller använd chatten i
          appen/på webben
        </li>
      </ul>
    </article>
  )
}
